import { UserProfileFields } from '@insided/deprecated-control/UserOverview/DataSource'
import { CustomProfileField } from '@insided/deprecated-control/UserOverview/Columns'

interface Props {
  userProfileFields: UserProfileFields
  profileFieldConfig: CustomProfileField
}

const ProfileFieldCell = ({ userProfileFields, profileFieldConfig }: Props) => {
  return (
    <div>
      {profileFieldConfig &&
        userProfileFields &&
        getCellValue(userProfileFields, profileFieldConfig)}
    </div>
  )
}

const getCellValue = (
  userProfileFields: UserProfileFields,
  customProfileField: CustomProfileField
): string => {
  const configId = customProfileField.id

  if (configId && configId in userProfileFields) {
    const profileFieldValues = userProfileFields[configId]

    if (Array.isArray(profileFieldValues)) {
      return profileFieldValues.map((key: string) => customProfileField.data?.[key]).join(',')
    }

    return profileFieldValues
  }

  return ''
}

export default ProfileFieldCell
